import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component DollarCheckmarkSmallIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <DollarCheckmarkSmallIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <DollarCheckmarkSmallIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const DollarCheckmarkSmallIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={12}
      height={12}
      viewBox="0 0 12 12"
      data-testid="DollarCheckmarkSmallIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="m11.243 8.121.707.707-2.829 2.829L7 9.536l.707-.708 1.414 1.414zM5.5 0a5.5 5.5 0 0 1 5.293 7l-1.05.001A4.5 4.5 0 1 0 6 9.972v1.006A5.5 5.5 0 1 1 5.5 0M6 2v1h1v1H5v1h2v3H6v1H5V8H4V7h2V6H4V3h1V2z"
      />
    </svg>
  )
);
DollarCheckmarkSmallIcon.displayName = "DollarCheckmarkSmallIcon";
export default DollarCheckmarkSmallIcon;
